export * from "./layout";

export const domineNameReGex = /abatech.app/;
